import { useProductPlanFormModelContext } from "../context";
import { QuestionPlanBase } from "./base/root";
import { QuestionPlanConnection } from "./connection/root";
import { QuestionPlanEmail } from "./email/root";
import { QuestionPlanAttributes } from "./plan-attributes/root";
import { QuestionPlanPreQuestions } from "./pre-questions/root";
import { QuestionPlanPriceAndPolicy } from "./price-and-policy/root";
import { QuestionPlanStayLength } from "./stay-length/root";
import { QuestionPlanStock } from "./stock/root";
import { QuestionPlanTerm } from "./term/root";

import type { PlanCategoriesAndManagerStore } from "../store/categories";

type Props = {
	planCategoriesAndManagerStore: Omit<PlanCategoriesAndManagerStore, "categoryManagerStore" | "categoryStoreArray">;
};

export const PlanFormMain = ({ planCategoriesAndManagerStore }: Props) => {
	const { hotelID, planID, name } = useProductPlanFormModelContext().viewModel;

	const { base, connection, priceAndPolicy, email, preQuestions, term, stock, stayLength, planAttributes } =
		planCategoriesAndManagerStore;

	return (
		<>
			<QuestionPlanBase base={base} hotelID={hotelID} planID={planID} />
			<QuestionPlanConnection connection={connection} />
			<QuestionPlanPriceAndPolicy priceAndPolicy={priceAndPolicy} />
			<QuestionPlanTerm term={term} />
			<QuestionPlanStock stock={stock} />
			<QuestionPlanPreQuestions preQuestions={preQuestions} />
			<QuestionPlanEmail email={email} name={name.value} hotelID={hotelID} />
			<QuestionPlanAttributes planAttributes={planAttributes} />
			<QuestionPlanStayLength stayLength={stayLength} />
		</>
	);
};

PlanFormMain.displayName = "PlanFormMain";
